import React, { useState, useEffect } from "react";
import {
  BaseUrl,
  newBaseUrlLang,
  systemTimeZone,
} from "../../Container/BaseUrl/BaseUrl";
import { connect } from "react-redux";
import { CloudFog, Eye, PlayCircle } from "@phosphor-icons/react";
import {
  setSelectedMenu,
  getAvailableAgentList,
} from "../../Redux/Actions/actions";
import axios from "axios";
import { IoIosArrowBack } from "react-icons/io";
import { toast } from "react-toastify";
import {
  ButtonGroup,
  Button,
  Pagination,
  Stack,
  Typography,
  Box,
  TableSortLabel,
  styled,
  InputBase,
  alpha,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { Badge } from "react-bootstrap";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import facebook from "../../Assets/images/other/facebook.png";
import whatsapp from "../../Assets/images/other/whatsapp.png";
import webchat from "../../Assets/images/other/chat-icon.png";
import twitter from "../../Assets//images/other/twitter.png";
import email from "../../Assets/images/other/email.png";
import voice from "../../Assets//images/other/voice.png";
import { DownloadSimple, FunnelSimple } from "@phosphor-icons/react";
import moment from "moment";
import moment2 from "moment-timezone";
import { Drawer } from "@mui/material";
import ViewMoreDialogBox from "./ViewMoreDialogBox";
import { toaststyle } from "../../Utils/toaststyle";
import { Hourglass } from "react-loader-spinner";
import {
  StyledPaper,
  StyledTableContainer,
  StyledTable,
  StyledTableHead,
  StyledTableBody,
  StyledTableRow,
  StyledTableCell,
  StyledTableCell2,
  Search,
  SearchIconWrapper,
  StyledInputBase,
} from "../../CustomComponent/TableCompoent";
import Nodata from "../../Assets/images/svg/Data-unavailable.svg";
import {
  TextMsg,
  Timeline,
  VideoMsg,
  AudioMsg,
  DocMsg,
  ImageMsg,
} from "../chat-components/Chat-component/MessageTypes-component/PreviewMsgType";
const headersData = [
  "Customer Name",
  "Phone Number",
  "Email",
  "Agents",
  "Initiated At",
  "Started At",
  "Ended At",
  "Comments",
  "Disposition",
  "Channel",
  "Direction",
  "Duration",
  "Status",
  "Skillset",
  "Language",
  "Message Count",
  "Call Status",
  "Action",
];

const mapStateToProps = (state) => {
  return {
    selectedMenu: state.contactListData.selectedMenu,
    DropDownAgentList: state.contactListData.DropDownAgentList,
  };
};
const Sessionreport = (props) => {
  const basedOnRole = JSON.parse(localStorage.getItem("tokenAgent"));
  const tenantId = localStorage.getItem("TenantId");
  const nationWideTenantId = "cb0efb28-e09e-4468-98ff-7ae9524347d5";
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];
  const [showfilter, setshowfilter] = useState(false);
  const [skilldropdown, setSkilldropdown] = useState([]);
  const [languagedropdown, setLanguagedropdown] = useState([]);
  const [disposition, setDisposition] = useState([]);
  const [fromdate, setFromdate] = useState(defaultValue);
  const [todate, setTodate] = useState(defaultValue);
  const [status, setStatus] = useState("");
  const [agentid, setAgentid] = useState("");
  const [dispositionvalue, setDispositionvalue] = useState("");
  const [sessionreport, setSessionreport] = useState([]);

  const [pagination, setPagination] = useState(0);
  const [page, setPage] = useState(1);
  const [direction, setdirection] = useState("");
  const [fromDateError, setFromDateError] = useState(false);
  const [phonenumber, setPhonenumber] = useState("");

  const [calldetailsreportspinner, setCalldetailsreportspinner] =
    useState(false);
  const [userdetails, setuserdetails] = useState();
  const [openDialogbox, setopenDialogbox] = useState(false);
  const [interactiontype, setInteractiontype] = useState("");
  const [searchedValues, setSearchedValues] = useState({
    customer: "",
    comments: "",
    channel: "",
    direction: "",
    disposition: "",
    email: "",
    language: "",
    phone: "",
    status: "",
    skillset: "",
    dispositionvalue: "",
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [chatHistory, setChatHistory] = useState([]);

  const showChatHistoryDialogBox = async (rowData) => {
    try {
      const response = await axios.post(
        `${BaseUrl}/message/chatHistories/`,
        { sessionId: rowData.chat_session_id },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      );

      // Handling the response
      if (response.data.status) {
        setChatHistory(response.data.data);
      } else {
        setChatHistory([]); // Set empty chat history if no data
      }
      setOpenDialog(true); // Open modal dialog
    } catch (err) {
      console.error("Error fetching chat history", err); // Log the error
      setChatHistory([]); // Set empty chat history on error
      setOpenDialog(true); // Open modal dialog
    }
  };

  const handleClose = () => {
    setOpenDialog(false); // Close modal
  };
  useEffect(() => {
    if (basedOnRole.role == "Supervisor") {
      props.getAvailableAgentList();
    }
  }, []);

  useEffect(() => {
    sessionReports();
  }, [page]);

  const sessionReports = async (props) => {
    setCalldetailsreportspinner(true);
    const currentDate = new Date().toISOString().split("T")[0];
    const isCurrentDate = fromdate === currentDate && todate === currentDate;
    await axios
      .post(
        BaseUrl + "/reports/listDetails",
        {
          agent_id: basedOnRole.role == "Supervisor" ? agentid : basedOnRole.id,
          agent_supervisor: basedOnRole.id,
          status: status,
          type: interactiontype ? interactiontype : "",
          from_date: fromdate ? fromdate : "",
          to_date: todate ? todate : "",
          limit: 10,
          offset: page == 1 ? 0 : (page - 1) * 10,
          agent: basedOnRole.role == "Supervisor" ? agentid : "",
          direction: direction,
          phonenumber: phonenumber,
          disposition: dispositionvalue,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.success == true) {
          setSessionreport(res.data.Data);
          setPagination(res.data.count);
          setCalldetailsreportspinner(false);
        } else {
          setSessionreport([]);
          setPagination(0);
          setCalldetailsreportspinner(false);
        }
      })
      .catch((error) => {
        setCalldetailsreportspinner(false);
      });
  };

  const sessionReports1 = async (ToPage1) => {
    setCalldetailsreportspinner(true);
    const currentDate = new Date().toISOString().split("T")[0];
    const isCurrentDate = fromdate === currentDate && todate === currentDate;
    await axios
      .post(
        BaseUrl + "/reports/listDetails",
        {
          agent_id: basedOnRole.role == "Supervisor" ? agentid : basedOnRole.id,
          agent_supervisor: basedOnRole.id,
          status: status,
          type: interactiontype ? interactiontype : "",
          from_date: fromdate ? fromdate : "",
          to_date: todate ? todate : "",
          limit: 10,
          offset: ToPage1,
          agent: basedOnRole.role == "Supervisor" ? agentid : "",
          direction: direction,
          phonenumber: phonenumber,
          disposition: dispositionvalue,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.success == true) {
          setSessionreport(res.data.Data);
          setPagination(res.data.count);
          setCalldetailsreportspinner(false);
        } else {
          setSessionreport([]);
          setPagination(0);
          setCalldetailsreportspinner(false);
        }
      })
      .catch((error) => {
        setCalldetailsreportspinner(false);
      });
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  const DownloadSessionReports = () => {
    axios
      .post(
        BaseUrl + "/reports/listDetailsExcel",
        {
          agent_id: basedOnRole.role == "Supervisor" ? agentid : basedOnRole.id,
          agent_supervisor: basedOnRole.id,
          status: status,
          type: interactiontype ? interactiontype : "",
          from_date: fromdate ? fromdate : "",
          to_date: todate ? todate : "",
          agent: basedOnRole.role == "Supervisor" ? agentid : "",
          direction: direction,
          phonenumber: phonenumber,
          disposition: dispositionvalue,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        },
        {}
      )
      .then((res) => {
        if (res.data.status == true) {
          let file =
            localStorage.getItem("frontendBaseURL") +
            "files" +
            res.data.message;
          window.open(file);
        } else {
          toast.warn("No Data Found", toaststyle);
        }
      })
      .catch((error) => {});
  };

  const ViewMore = (id) => {
    axios
      .post(
        BaseUrl + "/reports/viewmore",
        {
          id: id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          setuserdetails(res.data.Data[0]);
          setopenDialogbox(true);
        }
      })
      .catch((err) => {});
  };

  const ChatPull = (value) => {
    let agent = JSON.parse(localStorage.getItem("tokenAgent"));
    axios
      .post(
        BaseUrl + "/users/chatpull",
        {
          chat_session_id: value.chat_session_id,
          agent_id: agent.agent_id,
          user_id: agent.user_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {})
      .catch((err) => {});
  };

  const skillsetDropdown = () => {
    let data = {
      enabled: true,
    };
    axios
      .post(newBaseUrlLang + "usermodule/clientMaster/skills/list", data, {
        headers: {
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        setSkilldropdown(res.data.dataList);
      })
      .catch((error) => {});
  };
  const Dispositionlist = async () => {
    axios
      .post(
        BaseUrl + "/userstatus/dispositionlist",
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setDisposition(res.data.data);
        } else {
          setDisposition([]);
        }
      })
      .catch((err) => {});
  };
  const languageDropdownList = () => {
    let data = {
      enabled: true,
    };
    axios
      .post(newBaseUrlLang + "usermodule/clientMaster/languages/list", data, {
        headers: {
          tenantId: localStorage.getItem("TenantId"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setLanguagedropdown(res.data.dataList);
      })
      .catch((error) => {});
  };

  const sortedItemsSkillset = skilldropdown ? skilldropdown.slice().sort() : [];

  sortedItemsSkillset.sort((a, b) => a.skillName.localeCompare(b.skillName));
  const sortedItemsLanguage = languagedropdown
    ? languagedropdown.slice().sort()
    : [];
  sortedItemsLanguage.sort((a, b) =>
    a.languageDesc.localeCompare(b.languageDesc)
  );

  const handleSearchValues = (event, header) => {
    const eventValue = header;
    const removeSpace = eventValue.split(" ");
    const headerVal = removeSpace[0];
    setSearchedValues({ ...searchedValues, [headerVal]: event.target.value });
  };

  const filteredData = sessionreport
    .map((row) => ({
      ...row,
      callStatus: row.record_update_link ? "Answered" : "Not Answered",
    }))
    .filter((row) => {
      return (
        (!searchedValues.customer ||
          (row.name || "")
            .toLowerCase()
            .includes(searchedValues.customer.toLowerCase())) &&
        (!searchedValues.email ||
          (row.email || "")
            .toLowerCase()
            .includes(searchedValues.email.toLowerCase())) &&
        (!searchedValues.phone ||
          (row.phone_number || "")
            .toLowerCase()
            .includes(searchedValues.phone.toLowerCase())) &&
        (!searchedValues.direction ||
          (row.direction || "")
            .toLowerCase()
            .includes(searchedValues.direction.toLowerCase())) &&
        (!searchedValues.status ||
          (row.status || "")
            .toLowerCase()
            .includes(searchedValues.status.toLowerCase())) &&
        (!searchedValues.skillset ||
          (row.skillset || "")
            .toLowerCase()
            .includes(searchedValues.skillset.toLowerCase())) &&
        (!searchedValues.language ||
          (row.language || "")
            .toLowerCase()
            .includes(searchedValues.language.toLowerCase())) &&
        (!searchedValues.comments ||
          (row.comments || "")
            .toLowerCase()
            .includes(searchedValues.comments.toLowerCase())) &&
        (!searchedValues.channel ||
          (row.channel || "")
            .toLowerCase()
            .includes(searchedValues.channel.toLowerCase())) &&
        (!searchedValues.call ||
          row.callStatus
            .toLowerCase()
            .includes(searchedValues.call.toLowerCase())) &&
        (!searchedValues.disposition ||
          (row.reason || "")
            .toLowerCase()
            .includes(searchedValues.disposition.toLowerCase()))
      );
    });

  useEffect(() => {
    Dispositionlist();
    languageDropdownList();
    skillsetDropdown();
  }, []);

  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("");

  const createSortHandler = (property) => (event) => {
    const isAsc = orderBy === property && order === "desc";
    setOrder(isAsc ? "asc" : "desc");
    setOrderBy(property);
  };

  return (
    <>
      {/* Report start  */}
      <StyledPaper>
        <div className="card Report-card w-100 border-0">
          {/* card-header  */}
          <div
            className="card-header border-0 d-flex align-items-center justify-content-between px-2"
            sx={{ fontWeight: 600, color: "#1473e6" }}
          >
            <div
              className="fw-bold fs-16"
              style={{
                textShadow: "1px 0px 0px #c2c2c27d",
                color: "#0b3363",
              }}
            >
              Session Reports
            </div>
            <div>
              <ButtonGroup
                variant="contained"
                aria-label="button group"
                disableElevation
                size="small"
                sx={{
                  textTransform: "capitalize",
                }}
              >
                {/* Back btn  */}
                {props.show && (
                  <Button
                    sx={{
                      textTransform: "capitalize",
                    }}
                    onClick={() => {
                      props.setSelectedMenu("ReportMenu");
                    }}
                  >
                    <IoIosArrowBack className="me-2" />
                    Back
                  </Button>
                )}
                {/* Download btn  */}
                <Button
                  sx={{
                    textTransform: "capitalize",
                  }}
                  onClick={DownloadSessionReports}
                >
                  <DownloadSimple className="me-2" />
                  Download
                </Button>
                {/* Filter btn  */}
                <Button
                  sx={{
                    textTransform: "capitalize",
                  }}
                  onClick={() => {
                    setshowfilter(true);
                  }}
                >
                  <FunnelSimple className="me-2" />
                  Filter
                </Button>
              </ButtonGroup>
            </div>
          </div>
          {/* card-body */}
          <div
            className="card-body p-1 vh-71 box-inset"
            sx={{
              justifyContent: "center",
              display: "flex",
              height: "calc(100% - 40px)",
              display: "flex",
              flexDirection: "column",
              gap: "10",
            }}
          >
            <StyledTableContainer sx={{ height: "26rem !important" }}>
              <StyledTable
                stickyHeader
                aria-label="sticky table"
                size={"small"}
              >
                <StyledTableHead>
                  <StyledTableRow>
                    {headersData
                      .filter((header) => {
                        if (header === "Call Status") {
                          return tenantId === nationWideTenantId;
                        }
                        return true;
                      })
                      .map((headers, index) => {
                        return (
                          <StyledTableCell
                            style={{ minWidth: "180px" }}
                            key={index}
                          >
                            {(() => {
                              switch (headers) {
                                case "Customer Name":
                                case "Phone Number":
                                case "Email":
                                case "Direction":
                                case "Call Status":
                                  return (
                                    <TableSortLabel
                                      direction={
                                        orderBy === headers ? order : "desc"
                                      }
                                      onClick={createSortHandler(headers)}
                                    >
                                      {headers}
                                    </TableSortLabel>
                                  );

                                default:
                                  return <>{headers}</>;
                              }
                            })()}
                          </StyledTableCell>
                        );
                      })}
                  </StyledTableRow>
                </StyledTableHead>
                <StyledTableBody>
                  <StyledTableRow>
                    {headersData.map((headers, index) => {
                      if (
                        headers === "Call Status" &&
                        tenantId !== nationWideTenantId
                      ) {
                        return null;
                      }

                      return (
                        <StyledTableCell
                          style={{ minWidth: "180px" }}
                          key={`search-${index}`}
                        >
                          {(() => {
                            switch (headers) {
                              case "Duration":
                              case "Initiated At":
                              case "Started At":
                              case "Ended At":
                              case "Agents":
                              case "Message Count":
                              case "Status":
                              case "Action":
                                return "--";

                              default:
                                return (
                                  <Search>
                                    <SearchIconWrapper>
                                      <FilterAltIcon
                                        fontSize="small"
                                        sx={{ fontSize: "15px" }}
                                      />
                                    </SearchIconWrapper>
                                    <StyledInputBase
                                      sx={{ fontSize: "12px" }}
                                      placeholder={`Search ${headers}...`}
                                      inputProps={{ "aria-label": "search" }}
                                      value={
                                        searchedValues[headers.toLowerCase()]
                                      }
                                      onChange={(event) =>
                                        handleSearchValues(
                                          event,
                                          headers.toLowerCase()
                                        )
                                      }
                                    />
                                  </Search>
                                );
                            }
                          })()}
                        </StyledTableCell>
                      );
                    })}
                  </StyledTableRow>
                  {calldetailsreportspinner ? (
                    <Stack
                      sx={{ position: "absolute", top: "50%", left: "50%" }}
                    >
                      <Hourglass
                        visible={true}
                        height="30"
                        width="30"
                        ariaLabel="hourglass-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        colors={["#2268a0", "#72a1ed"]}
                      />
                    </Stack>
                  ) : filteredData.length > 0 ? (
                    filteredData
                      .sort((a, b) => {
                        switch (orderBy) {
                          case "Customer Name":
                          case "Email":
                            return order === "asc"
                              ? a.name.localeCompare(b.name)
                              : b.name.localeCompare(a.name);
                          case "Phone Number":
                            return order === "asc"
                              ? a.phone_number.localeCompare(b.phone_number)
                              : b.phone_number.localeCompare(a.phone_number);
                          case "Direction":
                            return order === "asc"
                              ? a.direction.localeCompare(b.direction)
                              : b.direction.localeCompare(a.direction);
                          case "Call Status":
                            return order === "asc"
                              ? a.record_update_link.localeCompare(
                                  b.record_update_link
                                )
                              : b.record_update_link.localeCompare(
                                  a.record_update_link
                                );
                          default:
                            break;
                        }
                      })
                      .map((rowData, rowIndex) => (
                        <StyledTableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={rowIndex}
                        >
                          <StyledTableCell2>
                            {rowData.name ? rowData.name : "NA"}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {rowData.phone_number}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {rowData.email ? rowData.email : "NA"}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {rowData.agent_name ? rowData.agent_name : ""}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {moment2(rowData.chat_arrival_at)
                              .tz(systemTimeZone)
                              .format("L LT")}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {rowData.chat_started_at == null ||
                            rowData.chat_started_at == undefined ||
                            rowData.chat_started_at == ""
                              ? "--"
                              : moment(rowData.chat_started_at)
                                  .tz(systemTimeZone)
                                  .format("L LT")}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {rowData.chat_ended_at == null ||
                            rowData.chat_ended_at == undefined ||
                            rowData.chat_ended_at == ""
                              ? "--"
                              : moment(rowData.chat_ended_at)
                                  .tz(systemTimeZone)
                                  .format("L LT")}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {rowData.comments == null ||
                            rowData.comments == undefined ||
                            rowData.comments == ""
                              ? "NA"
                              : rowData.comments}
                          </StyledTableCell2>

                          <StyledTableCell2>
                            {rowData.reason == null ||
                            rowData.reason == undefined ||
                            rowData.reason == ""
                              ? "NA"
                              : rowData.reason}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {rowData.channel == "webchat" ? (
                              <img
                                className="icons-size"
                                src={webchat}
                                alt="webchat"
                              />
                            ) : rowData.channel == "from_whatsapp" ? (
                              <img
                                className="icons-size"
                                src={whatsapp}
                                alt="webchat"
                              />
                            ) : rowData.channel == "from_twitter" ? (
                              <img
                                className="icons-size"
                                src={twitter}
                                alt="webchat"
                              />
                            ) : rowData.channel == "voice" ? (
                              <img
                                className="icons-size"
                                src={voice}
                                alt="webchat"
                              />
                            ) : rowData.channel == "from_facebook" ? (
                              (
                                <img
                                  className="icons-size"
                                  src={facebook}
                                  alt="webchat"
                                />
                              ) || rowData.channel == "from_teams"
                            ) : (
                              <img
                                className="icons-size"
                                src={email}
                                alt="webchat"
                              />
                            )}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {rowData.direction ? rowData.direction : "NA"}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {rowData.chat_started_at && rowData.chat_ended_at
                              ? moment
                                  .utc(
                                    moment(rowData.chat_ended_at).diff(
                                      moment(rowData.chat_started_at)
                                    )
                                  )
                                  .format("HH:mm:ss")
                              : "--"}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {rowData.status === "chatEnded"
                              ? "Completed"
                              : rowData.status === "Abandoned"
                                ? "Abandoned"
                                : "Active"}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {rowData.skillset ? rowData.skillset : "NA"}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {rowData.language ? rowData.language : "NA"}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {rowData.messageCount == null ||
                            rowData.messageCount == undefined ||
                            rowData.messageCount == ""
                              ? "--"
                              : rowData.messageCount}
                          </StyledTableCell2>
                          {tenantId === nationWideTenantId ? (
                            <StyledTableCell2>
                              {rowData.record_update_link
                                ? "Answered"
                                : "Not Answered"}
                            </StyledTableCell2>
                          ) : (
                            ""
                          )}

                          <StyledTableCell2>
                            {rowData.channel === "webchat" ||
                            rowData.channel === "from_purple" ||
                            rowData.channel === "from_whatsapp" ? (
                              <Eye
                                onClick={() =>
                                  showChatHistoryDialogBox(rowData)
                                }
                                style={{ cursor: "pointer" }}
                                size={20}
                              />
                            ) : rowData.channel === "voice" &&
                              rowData.record_update_link ? (
                              <audio
                                controls
                                style={{ height: "20px", width: "150px" }}
                              >
                                <source
                                  src={rowData.record_update_link}
                                  type="audio/mpeg"
                                />
                              </audio>
                            ) : null}
                          </StyledTableCell2>
                        </StyledTableRow>
                      ))
                  ) : (
                    <Stack
                      sx={{
                        position: "absolute",
                        width: "100%",
                        height: "calc(100vh - 14rem)",
                      }}
                      justifyContent="center"
                      alignContent="center"
                    >
                      <Stack
                        className="text-muted"
                        direction="column"
                        justifyContent="center"
                        alignContent="center"
                      >
                        <span className="mx-auto">
                          <img
                            src={Nodata}
                            alt="pic"
                            style={{ width: "11rem", userSelect: "none" }}
                          />
                        </span>
                        <span className="mx-auto">
                          <h6
                            className="text-muted mt-3"
                            style={{ fontSize: "13px" }}
                          >
                            Data unavailable
                          </h6>
                        </span>
                      </Stack>
                    </Stack>
                  )}
                </StyledTableBody>
              </StyledTable>
            </StyledTableContainer>
          </div>
          {/* card-footer */}
          <div className="card-footer border-0">
            <Stack
              sx={{ width: "100%", height: "100%" }}
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              {/* Pagination content  */}
              <Typography variant="caption" sx={{ fontSize: "12px" }}>
                Showing {Math.min((page - 1) * 10 + 1, pagination)} to{" "}
                {Math.min(page * 10, pagination)} of {pagination} entries
              </Typography>
              {/* Pagination  */}
              <Pagination
                count={Math.ceil(pagination / 10)}
                page={page}
                shape="rounded"
                color="primary"
                size="small"
                style={{ float: "right" }}
                onChange={handleChange}
              />
            </Stack>
          </div>
        </div>
      </StyledPaper>
      {/* Report end  */}
      {/* ViewMoreDialogBox start  */}
      <Dialog
        open={openDialog}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="sm"
        fullWidth
        sx={{
          fontSize: "16px",
          fontWeight: 600,
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
        }}
      >
        <DialogTitle
          variant="subtitle2"
          sx={{
            fontSize: "16px",
            fontWeight: 600,
            boxShadow:
              "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
          }}
        >
          Interaction History
        </DialogTitle>
        <DialogContent className="pb-0">
          <DialogContentText
            id="alert-dialog-slide-description"
            className="mt-3"
            sx={{ display: "flex", justifyContent: "center", gap: 2 }}
          >
            <Box
              className="p-2 box-inset2 "
              sx={{
                flexGrow: 1,
                backgroundColor: "#edf4fd",
                borderRadius: 0,
                overflowY: "scroll",
                scrollBehavior: "smooth",
              }}
              p={1}
            >
              <Stack spacing={2}>
                {chatHistory.length > 0
                  ? chatHistory.map((el, index) => {
                      switch (el.msg_sent_type) {
                        case "NOTIFICATIONS":
                          return <Timeline el={el} key={index} />;
                        case "jpeg":
                        case "png":
                        case "IMAGE":
                          return <ImageMsg el={el} menu={false} key={index} />;
                        case "vnd.openxmlformats-officedocument.wordprocessingml.document":
                          return (
                            <DocMsg
                              el={el}
                              menu={false}
                              key={index}
                              type={"docx"}
                              size={"100px"}
                            />
                          );
                        case "pdf":
                          return (
                            <DocMsg
                              el={el}
                              menu={false}
                              key={index}
                              type={"pdf"}
                              size={"100px"}
                            />
                          );
                        case "vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                          return (
                            <DocMsg
                              el={el}
                              menu={false}
                              key={index}
                              type={"xlsx"}
                              size={"100px"}
                            />
                          );
                        case "plain":
                          return (
                            <DocMsg
                              el={el}
                              menu={false}
                              key={index}
                              type={"plain"}
                              size={"100px"}
                            />
                          );

                        case "msword":
                          return (
                            <DocMsg
                              el={el}
                              menu={false}
                              key={index}
                              type={"plain"}
                              size={"100px"}
                            />
                          );
                        case "AUDIO":
                          return <AudioMsg el={el} menu={false} key={index} />;
                        case "wav":
                          return <AudioMsg el={el} menu={false} key={index} />;
                        case "mp4":
                          return <VideoMsg el={el} menu={false} key={index} />;
                        case "VIDEO":
                          return <VideoMsg el={el} menu={false} key={index} />;
                        case "webm":
                          return <VideoMsg el={el} menu={false} key={index} />;
                        default:
                          return (
                            <TextMsg
                              el={el}
                              menu={false}
                              key={index}
                              size={"220px"}
                            />
                          );
                      }
                    })
                  : null}
              </Stack>
            </Box>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            sx={{ textTransform: "capitalize !important" }}
            variant="outlined"
            onClick={handleClose}
            size="small"
            disableElevation
            color="error"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {openDialogbox && (
        <ViewMoreDialogBox
          openDialogbox={openDialogbox}
          handleClose={handleClose}
          data={userdetails}
        />
      )}
      {/* ViewMoreDialogBox end  */}

      {/* Filters Drawer Start  */}
      <Drawer
        anchor="right"
        open={showfilter}
        onClose={() => {
          setshowfilter(false);
        }}
      >
        <Box style={{ width: "20rem" }}>
          {/* Drawer head start */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className="p-3 shadowDrawer"
          >
            <Typography variant="h3" gutterBottom className="drawer-title">
              Filters
            </Typography>
          </Stack>
          {/* Drawer head end */}
          {/* Drawer Content start */}
          <Stack
            className="p-3"
            style={{ height: "calc(100vh - 7rem)", overflowY: "scroll" }}
          >
            <form className="fs-13">
              <div className="custom_div">
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="fromdate" className="form-label">
                    From
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id=""
                    aria-describedby="date"
                    value={fromdate}
                    onChange={(e) => setFromdate(e.target.value)}
                    max={defaultValue}
                  />
                </div>
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="todate" className="form-label">
                    To
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id=""
                    aria-describedby="date"
                    value={todate}
                    onChange={(e) => setTodate(e.target.value)}
                    max={defaultValue}
                  />
                  {fromDateError ? (
                    <span
                      className="text-danger fw-500"
                      style={{ fontSize: "10px" }}
                    >
                      To Date Should Less Than From Date
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="Select" className="form-label">
                    Status
                  </label>
                  <select
                    className="form-select fs-13"
                    aria-label="Default select example"
                    onChange={(e) => setStatus(e.target.value)}
                    value={status}
                  >
                    <option value="">Select All</option>
                    <option value="Accept">Chat Accepted</option>
                    <option value="chatEnded">Chat Ended</option>
                    <option value="queued">Queued</option>
                    <option value="customerdisconnect">
                      Customer Disconnected
                    </option>
                    <option value="Abandoned">Abandoned</option>
                  </select>
                </div>

                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="Select" className="form-label">
                    Call Type
                  </label>
                  <select
                    className="form-select fs-13"
                    aria-label="Default select example"
                    onChange={(e) => setInteractiontype(e.target.value)}
                    value={interactiontype}
                  >
                    <option value="">Select All</option>
                    <option value="internal">Internal</option>
                    <option value="external">External</option>
                  </select>
                </div>
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="Select" className="form-label">
                    Direction
                  </label>
                  <select
                    className="form-select fs-13"
                    aria-label="Default select example"
                    onChange={(e) => setdirection(e.target.value)}
                    value={direction}
                  >
                    <option value="">Select All</option>
                    <option value="Inbound">Inbound</option>
                    <option value="Outbound">Outbound</option>
                    <option value="MC_Outbound">MC_Outbound</option>
                    <option value="CM_Outbound">CM_Outbound</option>
                  </select>
                </div>
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="Select" className="form-label">
                    Phone Number
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id=""
                    aria-describedby="date"
                    onInput={(e) => {
                      const value = e.target.value;
                      e.target.value = value.replace(/[^0-9]/g, "");
                    }}
                    value={phonenumber}
                    onChange={(e) => setPhonenumber(e.target.value)}
                  />
                </div>

                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="Select" className="form-label">
                    Disposition
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    onChange={(e) => setDispositionvalue(e.target.value)}
                    value={dispositionvalue}
                  >
                    <option value="NoDisposition">NoDisposition</option>
                    <option value="">NA</option>
                    {disposition.length > 0 ? (
                      disposition.map((item) => {
                        return (
                          <option
                            key={item.dispositionName}
                            value={item.dispositionName}
                          >
                            {item.dispositionName}
                          </option>
                        );
                      })
                    ) : (
                      <option value="">NA</option>
                    )}
                  </select>
                </div>
                {basedOnRole.role == "Supervisor" ? (
                  <div className="mb-3 d-flex flex-column text-start">
                    <label htmlFor="Select" className="form-label">
                      Agent Name
                    </label>
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      onChange={(e) => setAgentid(e.target.value)}
                      value={agentid}
                    >
                      <option value="">Select All</option>
                      {props.DropDownAgentList.length > 0 ? (
                        props.DropDownAgentList.map((item) => {
                          return (
                            <option key={item.id} value={item.id}>
                              {item.username}
                            </option>
                          );
                        })
                      ) : (
                        <option>No Agent Found</option>
                      )}
                    </select>
                  </div>
                ) : null}
              </div>
            </form>
          </Stack>
          {/* Drawer Content end */}
          {/* Drawer footer start */}
          <Stack
            className="p-2"
            sx={{
              position: "absolute",
              bottom: "0",
              background: "#f9f9f9",
              width: "100%",
              boxShadow:
                "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
            }}
            direction="row"
            justifyContent="space-between"
            alignContent="center"
          >
            <Button
              variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="error"
              disableElevation
              onClick={() => {
                setshowfilter(false);
              }}
            >
              Close
            </Button>
            <Button
              className="w-100"
              variant="contained"
              disableElevation
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              id="session_filter_Submit"
              onClick={() => {
                if (moment(fromdate).isAfter(todate)) {
                  setFromDateError(true);
                } else {
                  setFromDateError(false);
                  sessionReports1(0);
                  setPage(1);
                  setshowfilter(false);
                }
              }}
            >
              Submit
            </Button>
          </Stack>
          {/* Drawer footer end */}
        </Box>
      </Drawer>
      {/* Filters Drawer End  */}
    </>
  );
};

export default connect(mapStateToProps, {
  setSelectedMenu,
  getAvailableAgentList,
})(Sessionreport);
